module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-6-image-06f7b9b8f9a8211c26bdedfa873b8250.png";